<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-28 14:50:52
 * @LastEditors: 陈芳 1441861445@qq.com
 * @LastEditTime: 2023-03-27 11:18:31
-->
<template>
	<div class="commissionDrawer">
		<el-drawer title="设置提成比" :visible.sync="drawer" :wrapperClosable="false" @closed="handleClose" ref="drawer" size="724px">
			<Tip class="mb-20" :content="`提成比*实际成交金额所得即为${drName}提成，当月提成比例修改保存后将按最新比例重新计算提成，每日仅可修改1次`"></Tip>
			<el-form :model="divideForm" ref="form" :rules="rules">
				<el-form-item label-width="110px" prop="rate">
					<div slot="label" class="flex-row yx-color-text-primary font-h4-regular">
						<Explain content="通过达人出单获得的提成比，提成金额=订单付款金额*达人提成比" placement="top"></Explain>
						<span class="ml-4">达人提成比</span>
					</div>
					<el-input v-model.trim="divideForm['rate']" autocomplete="off" placeholder="请输入" suffix-icon="suffix-icon"></el-input>
				</el-form-item>
				<el-form-item label-width="110px" prop="institution_rate">
					<div slot="label" class="flex-row yx-color-text-primary font-h4-regular">
						<Explain content="由团长分销产生的订单，员工应获得的提成比。提成金额=订单付款金额*团长提成比" placement="top"></Explain>
						<span class="ml-4">团长提成比</span>
					</div>
					<el-input v-model.trim="divideForm.institution_rate" autocomplete="off" placeholder="请输入" suffix-icon="suffix-icon"></el-input>
				</el-form-item>
			</el-form>
			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { drRoleType } from '@/utils/dataMap';
import throttle from 'lodash/throttle';
import Explain from '@/components/common/explain';
import { achievementSet } from '@/api/teamManage';
import { checkCommission } from '@/utils/validate';
export default {
	name: 'commissionDrawer',
	data() {
		return {
			drawer: false,
			divideForm: {
				rate: 0,
				institution_rate: 0,
			},
			user_ids: [],
			rules: {
				rate: [
					{ required: true, message: '请输入提成比', trigger: 'blur' },
					{ validator: checkCommission, trigger: 'blur' },
				],
				institution_rate: [
					{ required: true, message: '请输入提成比', trigger: 'blur' },
					{ validator: checkCommission, trigger: 'blur' },
				],
			},
		};
	},
	mounted() {},
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	components: {
		Explain,
	},
	methods: {
		show({ rateValue, institutionRateValue, id }) {
			this.user_ids = [id] || '';
			this.divideForm.rate = rateValue || '';
			this.divideForm.institution_rate = institutionRateValue || '';
			this.drawer = true;
		},
		//格式化数据 若是以0开头的正整数则去掉0
		save: throttle(async function () {
			const {
				user_ids,
				divideForm: { rate, institution_rate },
			} = this;
			const parmas = {
				user_ids,
				rate: Number(rate),
				institution_rate: Number(institution_rate),
			};
			this.$refs.form.validate(async valid => {
				if (valid) {
					const { code } = await achievementSet(parmas);
					if (code === 0) {
						this.drawer = false;
						this.$message.success('设置完成，当月提成将按最新提成比统计');
						this.$emit('getUsersList');
					}
				}
			});
		}, 2000),
		handleClose() {
			this.drawer = false;
			this.$refs.form.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.commissionDrawer {
	/deep/ .el-drawer__body {
		padding: 24px 25px;
	}
	/deep/ .el-form-item__label:before {
		display: none;
	}
	/deep/ .el-input__suffix {
		height: 92%;
		right: 1px;
		top: -1px;
	}
}
.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: fixed;
	bottom: 0px;
	margin-left: -25px;
	width: 724px;
	height: 64px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	&/deep/.el-button + .el-button {
		margin-right: 15px !important;
		margin-left: 16px !important;
		width: 88px;
	}
	&/deep/:first-child {
		width: 76px !important;
	}
}
</style>
